import { __commonJSMin as e } from "../../../../../../../_virtual/_rolldown/runtime.js";
//#region ../../node_modules/.pnpm/@intercom+intermoji@2.0.3/node_modules/@intercom/intermoji/lib/flatten.js
var t = /* @__PURE__ */ e(((e, t) => {
	var n = function(e) {
		return e.reduce(function(e, t) {
			return Array.isArray(t) ? e.concat(n(t)) : e.concat(t);
		}, []);
	};
	t.exports = n;
}));
//#endregion
export default t();
export { t as require_flatten };
